/* ==========================================================================
   Lumen — section-main-cart.js
   Keeps the cart PAGE in sync after AJAX cart changes. The interactions
   themselves (quantity steppers, [data-line-remove], [data-cart-note]) are
   handled by the cart.js engine; this listens for its 'cart:updated' event
   and re-renders this section via the Section Rendering API.
   No-JS fallback: the cart form posts normally with the Update button.
   ========================================================================== */
(function () {
  'use strict';

  var pending = false;
  var queued = false;

  function refresh() {
    var current = document.querySelector('[data-cart-page]');
    if (!current) return;
    var sectionId = current.getAttribute('data-section-id');
    if (!sectionId) return;
    if (pending) {
      queued = true;
      return;
    }
    pending = true;

    fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-page]');
        var target = document.querySelector('[data-cart-page]');
        if (!fresh || !target) return;

        var activeId = document.activeElement && document.activeElement.id;
        target.innerHTML = fresh.innerHTML;

        // Replaced markup misses the initial scroll-reveal pass — show it.
        target.querySelectorAll('.reveal').forEach(function (el) {
          el.classList.add('is-visible');
        });

        // Restore focus (e.g. the quantity input being edited).
        if (activeId) {
          var again = document.getElementById(activeId);
          if (again) again.focus();
        }
      })
      .catch(function () { /* keep current markup — no-JS path still works */ })
      .finally(function () {
        pending = false;
        if (queued) {
          queued = false;
          refresh();
        }
      });
  }

  document.addEventListener('cart:updated', refresh);
})();
